import { Directive, HostListener, inject, input } from '@angular/core';
import { environment } from '../../environments/environment';
import { LANGUAGE } from '../language';

@Directive({
  selector: '[maximizerShowcaseBookDemo]',
  standalone: true,
})
export class BookDemoDirective {
  private readonly language = inject(LANGUAGE);

  url = input<string>();

  @HostListener('click')
  onClick(): void {
    const defaultUrl = this.language.startsWith('fr')
      ? environment.bookDemoUrlFr
      : environment.bookDemoUrl;

    const url = this.url() ?? defaultUrl;

    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
